import React from 'react'

const MiscellaneousUpdate = () => {
  return (
    <div>MiscellaneousUpdate</div>
  )
}

export default MiscellaneousUpdate